import { Component, HostBinding, Input } from '@angular/core';

import { CountItem } from '@frontend/sports/common/core/data-access/sport-model';
import { ActiveModal } from '@frontend/sports/modal/feature';
import { CompetitionRoute } from '@frontend/sports/navigation/core/feature/models';

import { TreeItem } from '../../common/item/item.model';
import { CompetitionTreeComponent } from '../../competition-list/competition-tree.component';

@Component({
    selector: 'ms-calendar-competition-tree',
    templateUrl: './calendar-competition-tree.component.html',
    imports: [CompetitionTreeComponent],
})
export class CalendarCompetitionTreeComponent {
    @Input() sport?: CountItem;
    @Input() context: CompetitionRoute;
    @HostBinding('class') className = 'competition-tree';

    constructor(private modal: ActiveModal) {}

    itemClicked(item: TreeItem): void {
        this.modal.close(item);
    }
}
